module.exports = __webpack_public_path__ + "img/results_pull_maps.2d8c2d86.png";